export default {
  "home": "STARTSEITE",
  "news": "NEUIGKEITEN",
  "community": "COMMUNITY",
  "character": "CHARAKTERE",
  "world": "WELT EINSTELLUNGEN",
  "features": "FUNKTIONEN",
  "topUp": "AUFLADEN",
  "customerService": "KUNDENDIENST",
  "download": "DOWNLOAD",
  "moreDownload": "Weitere Download-Methoden",
  "screenshot": "SCREENSHOT",
  "video": "FILMISCH",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Zum Download QR-Code scannen.",
  "prev": "Vorher",
  "next": "Nächstes",
  "moreNews": "INFORMATION",
  "latest": "NEUESTE",
  "fwtk": "NUTZUNGSBEDINGUNGEN",
  "yszc": "DATENSCHUTZ-BESTIMMUNGEN",
  "noContent": "Noch kein Inhalt",
  "goPay": "LOS GEHT‘S",
  "payGuide": "MEHR ERFAHREN",
  "stayTurn": "Bleib dran!",
  "back": "Zurück",
}
